import initialState from './initialState';
import * as types from '../actions/actionTypes';

export default function postReducer(state = initialState.login, action) {
    switch (action.type) {
        case types.LOGIN_SUCCESS:
            return { ...state, authData: action.user }
        case types.OAUTH_LOGIN_SUCCESS:
            return { ...state, authData: action.data }
        case types.LOGOUT_SUCCESS:
            return initialState.login
        default:
            return state;
    }
}